var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 11.5998C17.1998 11.5998 11.5998 17.1998 11.5998 23.9998V40.1998H11.3998C9.7998 40.7998 8.7998 42.1998 8.7998 43.7998V47.7998H39.3998V43.7998C39.3998 42.1998 38.3998 40.5998 36.7998 40.1998H36.5998V23.9998C36.3998 17.1998 30.7998 11.5998 23.9998 11.5998ZM13.5998 23.9998C13.5998 18.1998 18.1998 13.5998 23.9998 13.5998C29.7998 13.5998 34.3998 18.1998 34.3998 23.9998V40.1998H13.5998V23.9998ZM37.1998 43.9998V45.7998H10.7998V43.9998C10.7998 42.9998 11.5998 42.1998 12.5998 42.1998H35.3998C36.3998 42.1998 37.1998 42.9998 37.1998 43.9998Z",
    fill: "#182F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 20H23V27.8H25.2V20Z",
    fill: "#182F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 31.4002H23V33.6002H25.2V31.4002Z",
    fill: "#182F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23H0V25.2H5V23Z",
    fill: "#182F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23H43V25.2H48V23Z",
    fill: "#182F88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1283 6.3706L36.5928 9.9061L38.1484 11.4617L41.6839 7.92622L40.1283 6.3706Z",
    fill: "#182F88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92574 6.31575L6.37012 7.87137L9.90562 11.4069L11.4612 9.85125L7.92574 6.31575Z",
    fill: "#182F88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0H23V5H25.2V0Z",
    fill: "#182F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.d4c55cbd.svg";
export { ForwardRef as ReactComponent };